import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import EvistampLogo from "../images/zLogoEvistamp.png"

const Evistamp = () => {
  return (
    <Layout>
      <Seo
        title="Evistamp | Ricta Technologies"
        description="The First NextGen Multi Blockchain SaaS and API Timestamp solution"
      />
      <div className="min-h-screen flex flex-col items-center justify-center py-16 px-4">
        <div className="text-center">
          <div className="mb-8">
            <img
              src={EvistampLogo}
              alt="Evistamp Logo"
              className="mx-auto w-48 h-48 object-contain"
            />
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-mainColor text-center max-w-4xl mx-auto leading-tight">
            The First NextGen Multi Blockchain SaaS and API Timestamp solution
          </h1>
        </div>
      </div>
    </Layout>
  )
}

export default Evistamp
